import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchDropdownList = createAsyncThunk('getDropdownList/fetchDropdownList',
  async (_, { rejectWithValue }) => {
    try {
      const url = `${api.getDropdownList}`
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const getDropdownListSlice = createSlice({
  name: 'dropdownList',
  initialState: {
    dropdownList: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders.
      addCase(fetchDropdownList.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchDropdownList.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.dropdownList = action.payload;
        })
      .addCase(fetchDropdownList.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getDropdownListSlice.reducer;